import React, {useState, useContext, useEffect} from 'react';
import API from '../servicios/api';

// Creamos el contexto = estado global
const AuthContext = React.createContext();

// Hook para acceder al contexto
const useAuth = () => {
    return useContext(AuthContext);
}

const AuthProvider = ({children}) => {
    const [usuarioActivo, setUsuarioActivo] = useState(false);
    const [idUsuario, setIdUsuario] = useState();
    const [nombresUsuario, setNombresUsuario] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [idTipoUsuario, setIdTipoUsuario] = useState(0);

    //Este hook se ejecuta cada vez que hay un cambio en usuarioActivo
    useEffect(() => {
        var datosEnviar = {email:sessionStorage.getItem('email'), clave:sessionStorage.getItem('password')}
        fetch(API+"?setAuthContext=1",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setNombresUsuario(datosRespuesta[0].nombres);
            setIdUsuario(datosRespuesta[0].id);
            setIdTipoUsuario(datosRespuesta[0].idTipoUsuario)
        })
        .catch(console.log)
    }, [usuarioActivo, email, password]);
    
    const sesionOn = () => {
        sessionStorage.setItem('sesion', 'true');
        setUsuarioActivo(true)
    }

    const sesionOff = () => {
        setUsuarioActivo(false);
        setEmail('');
        setPassword('');
    }

    return (
        <AuthContext.Provider value={{usuarioActivo: usuarioActivo, nombresUsuario: nombresUsuario, idUsuario:idUsuario, idTipoUsuario:idTipoUsuario, setIdTipoUsuario:setIdTipoUsuario, setNombresUsuario:setNombresUsuario, setIdUsuario:setIdUsuario, setEmail:setEmail, setPassword:setPassword, sesionOn, sesionOff}}>
            {children}
        </AuthContext.Provider>
    );
}
 
export {AuthProvider, AuthContext, useAuth};